import { Button, ButtonProps } from '@forgeglobal/design-framework';
import { useStyles } from './style';
import type { Status } from '@tcs/common/types';

export interface StatusButtonProps extends ButtonProps {
  status: Status;
}

const StatusButton = ({ status, ...rest }: StatusButtonProps) => {
  const classes = useStyles();

  return <Button className={classes[status]} {...rest} />;
};

export default StatusButton;
